import { createNewTeam } from "api/Settings";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useCreateNewTeam = () => {
    const queryClient = useQueryClient();
    return useMutation(createNewTeam, {
        onSuccess: () => {
            queryClient.invalidateQueries('teams');
            toast.success("Created Successfully");
        },
        onError: (error: any) => {
            if(error?.response?.data?.message) { 
                toast.error(error?.response?.data?.message);
                return;
            }
            if(error?.response?.data?.error) { 
                toast.error(error?.response?.data?.error);
                return;
            }
            toast.error(`Something went wrong`);
        },
    });
};
